"use strict";

exports.__esModule = true;
exports.ElementEditorChooseTemplateDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _ElementThumbnail = require("../../ElementThumbnail");
var _Theme = require("../../../Theme");
var _Core = require("../../../Core");
var _LayoutTemplate = require("../../../LayoutTemplate");
var _API = require("../../../API");
var _common = require("../../common");
var _dec, _class, _ElementEditorChooseTemplateDialog;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TemplateDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "ElementEditorChooseTemplateDialog__TemplateDialog",
  componentId: "sc-17kcq7l-0"
})(["width:800px;.", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);
var GroupListContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorChooseTemplateDialog__GroupListContainer",
  componentId: "sc-17kcq7l-1"
})(["height:600px;overflow-y:auto;"]);
var GroupListItem = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorChooseTemplateDialog__GroupListItem",
  componentId: "sc-17kcq7l-2"
})(["margin-top:1rem;"]);
var TemplateListContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorChooseTemplateDialog__TemplateListContainer",
  componentId: "sc-17kcq7l-3"
})(["display:grid;height:100%;padding:1rem;grid-gap:1rem;grid-template-columns:repeat(auto-fill,minmax(calc(128px + 1rem),1fr));grid-template-rows:repeat(auto-fill,calc(128px + 2rem));"]);
var TemplateListItem = _styledComponents["default"].button.withConfig({
  displayName: "ElementEditorChooseTemplateDialog__TemplateListItem",
  componentId: "sc-17kcq7l-4"
})(["cursor:pointer;color:", ";background:", ";border:solid 1px ", ";padding:0.5rem;display:flex;flex-direction:column;align-items:center;justify-content:space-between;"], (0, _Theme.selectable)("ThumbnailListItemColor"), (0, _Theme.selectable)("ThumbnailListItemBackground"), (0, _Theme.selectable)("ThumbnailListItemBorderColor"));
var TemplateListItemLabel = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorChooseTemplateDialog__TemplateListItemLabel",
  componentId: "sc-17kcq7l-5"
})(["text-align:center;"]);
var ElementEditorChooseTemplateDialog = exports.ElementEditorChooseTemplateDialog = (_dec = _LayoutTemplate.LayoutTemplateCollectionContext.withContext, _dec(_class = (_ElementEditorChooseTemplateDialog = /*#__PURE__*/function (_Component) {
  function ElementEditorChooseTemplateDialog() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      components: collectThumbnailComponents(_this.props.elementEditor.widgets),
      searchTerm: ""
    };
    _this.handleSearchTermChange = function (searchTerm) {
      _this.setState({
        searchTerm: searchTerm
      });
    };
    _this.handleTemplateClick = function (template) {
      var elementEditor = _this.props.elementEditor;
      var existingElement = elementEditor.getElementAt(elementEditor.selectedPath);
      if (!existingElement) {
        return;
      }
      var replacement = {
        type: template.element.type,
        props: Object.assign({}, template.element.props, {
          x: existingElement.props.x,
          y: existingElement.props.y,
          width: existingElement.props.width,
          height: existingElement.props.height,
          gridRowStart: existingElement.props.gridRowStart,
          gridRowEnd: existingElement.props.gridRowEnd,
          gridColumnStart: existingElement.props.gridColumnStart,
          gridColumnEnd: existingElement.props.gridColumnEnd
        }),
        children: template.element.children
      };
      elementEditor.replaceElementAt(elementEditor.selectedPath, replacement);
      elementEditor.closeChooseTemplateDialog();
    };
    return _this;
  }
  _inheritsLoose(ElementEditorChooseTemplateDialog, _Component);
  var _proto = ElementEditorChooseTemplateDialog.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      layoutTemplateCollection = _this$props.layoutTemplateCollection;
    return /*#__PURE__*/_react["default"].createElement(TemplateDialog, {
      isOpen: elementEditor.isChooseTemplateDialogOpen,
      onClose: elementEditor.closeChooseTemplateDialog,
      icon: _icons.IconNames.EXCHANGE,
      title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementEditorChooseTemplateDialog.title",
        defaultMessage: "Choose Template"
      })
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: _core.Classes.DIALOG_BODY
    }, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput
    // eslint-disable-next-line jsx-a11y/no-autofocus
    , {
      autoFocus: true,
      value: this.state.searchTerm,
      onChange: this.handleSearchTermChange
    }), /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
      collection: layoutTemplateCollection,
      term: this.state.searchTerm
    }, function (_ref) {
      var fetching = _ref.fetching,
        data = _ref.data,
        error = _ref.error;
      if (fetching) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error
        });
      }
      if (data) {
        return _this2.renderThumbnails(data);
      }
      return null;
    })), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _core.Classes.DIALOG_FOOTER
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER_ACTIONS
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      large: true,
      minimal: true,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementEditorChooseTemplateDialog.cancelButton",
        defaultMessage: "Cancel"
      }),
      onClick: elementEditor.closeChooseTemplateDialog
    }))));
  };
  _proto.renderThumbnails = function renderThumbnails(templates) {
    var _this3 = this;
    var elementEditor = this.props.elementEditor;
    var searchTerm = this.state.searchTerm;
    var widgetGroups = elementEditor.widgets.reduce(function (groups, widget) {
      var element = widget.createElement({});
      if (elementEditor.canReplaceElementAt(elementEditor.selectedPath, element)) {
        if (searchTerm && !widget.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          return groups;
        }
        groups[widget.name] = [{
          id: "default-template-" + widget.name,
          name: "Default",
          element: element
        }];
      }
      return groups;
    }, {});
    var groups = templates.reduce(function (groups, template) {
      if (!elementEditor.canReplaceElementAt(elementEditor.selectedPath, template.element)) {
        return groups;
      }
      var group = groups[template.element.type];
      if (!group) {
        group = [];
        groups[template.element.type] = group;
      }
      group.push(template);
      return groups;
    }, widgetGroups);
    if (Object.keys(groups).length === 0) {
      return /*#__PURE__*/_react["default"].createElement(GroupListContainer, null, /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
        visual: _icons.IconNames.SEARCH,
        title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementEditorChooseTemplateDialog.noResults.title",
          defaultMessage: "No Results"
        }),
        description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementEditorChooseTemplateDialog.noTemplates.title",
          defaultMessage: "No templates match your query."
        })
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(GroupListContainer, null, Object.keys(groups).map(function (type) {
      var widget = (0, _common.getWidget)(elementEditor.widgets, type);
      if (!widget) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(GroupListItem, {
        key: widget.name
      }, /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
        level: 4
      }, widget.label), /*#__PURE__*/_react["default"].createElement(TemplateListContainer, null, groups[type].map(function (template) {
        return /*#__PURE__*/_react["default"].createElement(TemplateListItem, {
          key: template.id,
          onClick: function onClick() {
            return _this3.handleTemplateClick(template);
          }
        }, /*#__PURE__*/_react["default"].createElement(_ElementThumbnail.ElementThumbnail, {
          components: _this3.state.components,
          height: 96,
          width: 96,
          config: template.element
        }), /*#__PURE__*/_react["default"].createElement(TemplateListItemLabel, null, template.name));
      })));
    }));
  };
  return ElementEditorChooseTemplateDialog;
}(_react.Component), _ElementEditorChooseTemplateDialog.defaultProps = {
  translator: undefined,
  layoutTemplateCollection: undefined
}, _ElementEditorChooseTemplateDialog)) || _class);
function collectThumbnailComponents(widgets) {
  var components = {};
  for (var i = 0; i < widgets.length; i++) {
    var widget = widgets[i];
    if (widget.components.Thumbnail) {
      components[widget.name] = widget.components.Thumbnail;
    }
  }
  return components;
}